import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLenis } from 'lenis/react';

/**
 * Resets scroll to the top whenever the pathname changes.
 *
 * Uses the Lenis instance from <ReactLenis root> when present, falling
 * back to window.scrollTo so it still works if Lenis is disabled
 * (e.g. prefers-reduced-motion).
 *
 * Skips when navigating to a URL with a hash so anchor links keep their
 * usual behaviour.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (hash) return;
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    }
  }, [pathname, hash, lenis]);

  return null;
}
